<template>
  <div class="orderPage">
    <!-- <div class="search_wrap flex-between">
      <van-field v-model="params.order_id" placeholder="输入订单号查找→" />
      <div class="search_btn flex-rowc" @click="handleSearch">
        <i class="iconfont icon-chazhaotubiao"></i>
      </div>
    </div> -->
    <div class="select_wrap flex-between">
      <div class="dropdown_wrap">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="params.complaint_dealstatus"
            :options="distriOrderState"
            @change="changeDropdownStatus"
          />
        </van-dropdown-menu>
      </div>
      <div class="search_btn flex-rowc" @click="isShowPopup = true">
        查找订单 <i class="iconfont icon-chazhaotubiao"></i>
      </div>
    </div>
    <div class="flex-between">
      <div class="radio_wrap flex-rowc">
        <van-checkbox
          v-model="checked"
          shape="square"
          checked-color="#ee0a24"
          @change="changeCheck"
        ></van-checkbox>
        <span>按筛选条件只看今天的订单</span>
      </div>
      <div class="clear_condition" @click="handleClearParams">
        清空筛选条件
        <!-- 清空筛选条件（显示所有订单） -->
      </div>
    </div>
    <div class="order_num">查找到{{ total }}笔订单</div>
    <div class="order_wrap" @scroll="orderScroll($event)">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="list" v-if="dataList.length > 0">
          <div class="item" v-for="item in dataList" :key="item.id">
            <div class="block_one">
              <div
                class="column flex-rowl"
                @click="handleDetail(item.order_id)"
              >
                <p class="label">创建时间：</p>
                <!-- <p class="con red">{{ getTiemSplit(item.createdate) }}</p> -->
              </div>
              <div class="column flex-between">
                <div
                  class="left flex-rowl"
                  @click="handleDetail(item.order_id)"
                >
                  <p class="label">订单号：</p>
                  <p class="con">
                    {{ item.order_id }}
                  </p>
                </div>
                <div
                  class="btn_copy code"
                  :data-clipboard-text="item.order_id"
                  @click="handleCopy()"
                >
                  <i class="iconfont icon-fuzhi"></i>
                </div>
              </div>
            </div>
            <div class="block_one" @click="handleDetail(item.order_id)">
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label w">取件人姓名：</p>
                  <p class="con">
                    {{ item.get_truename }}
                  </p>
                </div>
              </div>
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label w1">取件人手机号：</p>
                  <p class="con">
                    {{ item.getlinkphone }}
                  </p>
                </div>
              </div>
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">取件类型：</p>
                  <p class="con">
                    {{ item.get_sitein == 2 ? '园区外' : '园区内' }}
                  </p>
                </div>
              </div>
              <div class="column flex-between" v-if="item.get_sitein == 2">
                <div class="left flex-rowl">
                  <p class="label">取件地址：</p>
                  <p class="con">
                    {{ item.province }}{{ item.city }}{{
                      item.area
                    }}{{ item.address }}
                  </p>
                </div>
              </div>
              <div class="column flex-between" v-else>
                <div class="left flex-rowl">
                  <p class="label">取件地址：</p>
                  <p class="con">
                   {{ item.getyuanqu }}{{ item.get_parameteridstr }}{{
                      item.get_buildingidstr
                    }}{{ item.get_addr }}
                  </p>
                </div>
              </div>
            </div>
             <div class="block_one" @click="handleDetail(item.order_id)">
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label w">送件人姓名：</p>
                  <p class="con">
                    {{ item.give_truename }}
                  </p>
                </div>
              </div>
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label w1">送件人手机号：</p>
                  <p class="con">
                    {{ item.givelinkphone }}
                  </p>
                </div>
              </div>
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">送件地址：</p>
                  <p class="con">
                    {{ item.takeyuanqu }}{{item.take_parameteridstr}}{{item.take_buildingidstr}}
                  </p>
                </div>
              </div>
            </div>
            <div class="block_one" @click="handleDetail(item.order_id)">
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">物件信息</p>
                </div>
              </div>
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">重量：</p>
                  <p class="con">{{ item.weight }}</p>
                </div>
              </div>
            </div>
            <div class="block_one" @click="handleDetail(item.order_id)">
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">服务进度：</p>
                  <p class="con red">
                    {{
                      item.server_state == 1
                        ? "待取件"
                        : item.server_state == 2
                        ? "已取件"
                        : item.server_state == 3
                        ? "送件中"
                        : "已送达"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty
          description="暂无订单"
          v-if="!isLoading && dataList.length == 0"
        />
      </van-pull-refresh>
      
    </div>
    <div class="custom_btn fixed" @click="handleReturn">返回</div>

    <!-- 选择类型弹窗 start -->
    <van-popup v-model="isShowPopup">
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="btn_item flex-between" @click="handleShowTextArea(1)">
            <p>手动输入订单号</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
          <div class="btn_item flex-between" @click="handleShowTextArea(2)">
            <p>点餐用户手机号查询</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
        </div>
        <div class="close" @click="isShowPopup = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-popup>
    <!-- 选择类型弹窗 end -->

    <!-- 输入框弹窗 start -->
    <van-popup v-model="isShowPopupTextarea">
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="textarea_box" v-if="popupType == 1">
            <van-field
              type="textarea"
              v-model="params.order_id"
              placeholder="输入订单号"
            />
          </div>
          <div class="textarea_box" v-else>
            <van-field
              type="textarea"
              v-model="params.linkphone"
              placeholder="输入手机号"
            />
          </div>
          <div class="custom_btn" @click="handleQuery">
            开始查找 <i class="iconfont icon-yuyinjiantou"></i>
          </div>
        </div>
        <div class="close" @click="isShowPopupTextarea = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-popup>
    <!-- 输入框弹窗 end -->
    
  </div>
</template>

<script>
import { getComplaintList, getToken } from "../../api/api";
import Clipboard from "clipboard";

export default {
  name: "pOrderMineListManage",
  data() {
    return {
      isShowPopupTextarea: false,
      isShowPopup: false,
      popupType: 1,
      // role 职能身份  "1","综合服务人员"|"2","取餐员"|"3","送餐员"|"4","点位服务人员"|"5","派单管理员"
      show: false,
      // 订单分配状态
      distriOrderState: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "客户投诉待处理",
          value: 0,
        },
        {
          text: "客户投诉已处理",
          value: 1,
        },
      ],

      checked: true,
      params: {
        Page: 1,
        token: "",
        PageSize: 20,
        complaint_dealstatus: '',  // 投诉处理进度状态 =0=客户投诉待处理 1=客户投诉已处理
        order_id: "",
        linkphone: "",
      },

      isLoading: true,
      total: 0,
      dataList: [],

      dept: "",
      userInfo: "",

      type: 1, // 1-跑腿&根据管理 2-跑腿业务服务管理
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.type = this.$route.params.type;
    this.params.reci_openid = userInfo.openid
    this.userInfo = userInfo;
    if (userInfo.dept.length > 0) {
      this.dept = userInfo.dept[0];
    }
    this.getToken();
  },
  computed: {
    getTiemSplit() {
      return function (data) {
        // let newData = data.split('T')[0] + ' ' + data.split('T')[1]
        let newData = data.replace("T", " ");
        return newData;
      };
    },
  },
  methods: {
    //
    handleShowTextArea(type) {
      this.isShowPopup = false;
      this.isShowPopupTextarea = true;
      this.popupType = type;
    },
    handleQuery() {
      this.params.Page = 1;
      this.dataList = [];
      this.isShowPopupTextarea = false;
      this.getToken();
    },
    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
          this.getParkOrderList();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },
    onRefresh() {
      this.params.Page = 1;
      this.getParkOrderList(true);
    },
    //
    getParkOrderList(isRefresh) {
      let { params } = this;
      let toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getComplaintList(params).then((res) => {
        if (res.error_code == 0) {
          if (isRefresh) {
            this.params.Page = 1;
            this.dataList = [];
          }
          this.total = res.data.total;
          this.dataList = this.dataList.concat(...res.data.list);
          this.isLoading = false;
        } else {
          this.dataList = [];
        }

        toast.clear();
      });
    },

    // 滚动事件
    orderScroll(e) {
      let el = e.target;
      //判断是否到达div容器底部
      let { total, dataList } = this;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        // if (listTotal > dataList.length) {
        //   this.params.Page += 1;
        //   this.initData();
        // }
        if (total > dataList.length) {
          this.params.Page += 1;
          this.getParkOrderList();
        }
      }
    },
    handleSearch() {
      this.params.Page = 1;
      this.dataList = [];
      this.getParkOrderList();
    },
    changeCheck(e) {
      this.params.istoday = e ? 1 : 0;
      this.params.Page = 1;
      this.dataList = [];
      this.getParkOrderList();
    },
    // 订单分配状态
    changeDropdownStatus(e) {
      this.params.complaint_dealstatus = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getParkOrderList();
    },
    handleClearParams() {
      this.params.complaint_dealstatus = "";
      this.params.order_id = "";
      this.params.linkphone = "";
      this.params.Page = 1;
      this.dataList = [];
      this.getParkOrderList();
    },
    /**
     * 复制功能
     */
    handleCopy() {
      var clipboard = new Clipboard(".code");
      console.log(clipboard, "=====clipboard");
      clipboard.on("success", (e) => {
        console.log("复制成功", e);
        this.$toast({
          message: "复制成功",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast({
          message: "手机权限不支持复制功能",
        });
        console.log("该浏览器不支持自动复制", e);
        // 释放内存
        clipboard.destroy();
      });
    },
    handleDetail(id) {
      this.$router.push(`/parkFlash/pDetailManag/${id}`);
    },

    // 返回上一页
    handleReturn() {
      this.$router.back();
    },

    // 关闭弹窗
    handleClosePopup() {
      this.isShow = false;
      this.getParkOrderList(true);
    },
  },
};
</script>
<style lang='less' scoped>
.orderPage {
  padding-top: 40px;
  .search_wrap {
    width: 660px;
    height: 80px;
    border: 1px solid rgba(173, 173, 173, 0.76);
    border-radius: 45px;
    margin: auto;
    background: #ffffff;
    padding: 0 20px;
    box-sizing: border-box;
    margin-bottom: 25px;
    /deep/ .van-cell {
      padding: 0;
      background: none;
      flex-shrink: 0;
      border: none;
      flex: 1;
    }
    /deep/ .van-field__control {
      text-align: center;
    }
    .search_btn {
      flex-shrink: 0;
      width: 70px;
      .iconfont {
        font-size: 40px;
        color: #d6d0d1;
      }
    }
  }
  .select_wrap {
    width: 660px;
    margin: auto;
    box-sizing: border-box;
    .dropdown_wrap {
      width: 500px;
      flex-shrink: 0;
    }
    .select_item {
      margin-top: 20px;
      height: 80px;
      border-bottom: 1px dashed #2c2b2b;
      font-size: 30px;
      color: #333333;
      padding: 0 14px;
      .icon-toTop {
        transform: rotate(180deg);
        font-size: 20px;
      }
    }
    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
      width: 100%;
    }
    /deep/ .van-dropdown-menu__title {
      width: 280px;
      box-sizing: border-box;
      text-align: center;
      padding: 0 30px 0 15px;
    }
    /deep/ .van-dropdown-menu__title::after {
      right: 20px;
      border-color: transparent transparent #c4c5c6 #c4c5c6;
    }
    .search_btn {
      flex-shrink: 0;
      width: 160px;
      font-size: 24px;
      background: #096f70;
      color: #fff;
      margin-left: 10px;
      white-space: nowrap;
      height: 90px;
      .iconfont {
        font-size: 28px;
        margin-left: 5px;
      }
    }
  }
  .radio_wrap {
    font-size: 24px;
    color: #1e1e1e;
    margin: 25px auto;
    span {
      margin-left: 16px;
    }
  }
  .clear_condition {
    width: 200px;
    height: 60px;
    background: #ffffff;
    border: 3px solid #096f70;
    border-radius: 35px;
    margin: auto;
    font-size: 24px;
    color: #096f70;
    text-align: center;
    line-height: 60px;
  }
  .order_num {
    width: 660px;
    margin: auto;
    font-size: 24px;
    color: #096f70;
  }
  .order_wrap {
    margin-top: 25px;
    height: 73vh;
    overflow-y: scroll;
    .list {
      padding-bottom: 190px;
      box-sizing: border-box;
      .item {
        width: 660px;
        // min-height: 700px;
        background: #ffffff;
        border: 6px solid #e6e6e6;
        border-radius: 40px;
        margin: 0 auto 30px;
        padding: 52px 44px;
        box-sizing: border-box;
        font-size: 28px;
        color: #040000;
        .block_one {
          font-size: 30px;
          margin-bottom: 45px;
          .column {
            &:nth-child(2n) {
              margin: 10px 0;
            }
            .label {
              width: 150px;
              &.w {
                width: 170px;
              }
              &.w1 {
                width: 200px;
              }
            }
            .con {
              &.red {
                color: #ff0000;
              }
            }
          }
        }
        .block_two {
          // margin-bottom: 99px;
          font-size: 28px;
          position: relative;
          .column {
            &:last-child {
              margin-bottom: 0;
            }
          }
          .order_state_operation {
            // position: absolute;
            // bottom: 0;
            // right: -30px;
            margin-top: 30px;
            .btn {
              width: 130px;
              height: 40px;
              background: #096f70;
              border-radius: 45px;
              text-align: center;
              font-size: 20px;
              color: #fff;
              &.disabled {
                background: #9e9e9e;
              }
            }
          }
        }

        .column {
          align-items: flex-start;
          &:nth-child(2n) {
            margin: 26px 0;
          }
          .left {
            align-items: flex-start;
            .con {
              width: 360px;
              flex-shrink: 0;
            }
          }
          .label {
            white-space: nowrap;
            width: 180px;
            flex-shrink: 0;
          }
          .con {
            word-wrap: break-word;
            flex-shrink: 0;
            width: 380px;
            span {
              margin-left: 10px;
            }
          }
          .iconfont {
            font-size: 30px;
          }
          &.order_content {
            .con {
              flex-shrink: 0;
              width: 270px;
            }
          }
        }
      }
    }
  }
  /deep/ .van-popup--bottom {
    bottom: 80px;
  }
  .custom_popup {
    width: 650px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -51%);
    .custom_close {
      position: fixed;
      right: 0;
      top: -70px;
      .iconfont {
        font-size: 52px;
        color: #fff;
        // font-weight: bold;
      }
    }
    .custom_popup_wrap {
      background: #ffffff;
      overflow-y: scroll;
      height: 84vh;
      .list {
        .item {
          // width: 660px;
          // min-height: 700px;
          // background: #ffffff;
          // border: 6px solid #e6e6e6;
          // border-radius: 40px;
          // margin: 0 auto 30px;
          // padding: 52px 44px 0;
          // box-sizing: border-box;
          // font-size: 28px;
          // color: #040000;
          margin: 0 auto 240px;
          padding: 52px 44px 0;
          box-sizing: border-box;
          font-size: 28px;
          color: #040000;
          .block_one {
            font-size: 30px;
            margin-bottom: 65px;
            .column {
              .label {
                width: 140px;
              }
              .con {
                color: #ff0000;
              }
            }
          }
          .block_two {
            margin-bottom: 99px;
          }
          .block_three {
            margin-bottom: 85px;
          }
          .btn {
            margin-bottom: 60px;
          }
          .column {
            align-items: flex-start;
            &:nth-child(2n) {
              margin: 26px 0;
            }
            .label {
              white-space: nowrap;
              width: 190px;
              flex-shrink: 0;
            }
            .con {
              word-wrap: break-word;
              flex-shrink: 0;
              width: 380px;
            }
          }
        }
      }
    }
  }
  .custom_btn {
    margin-top: 50px;
    &.fixed {
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      bottom: 190px;
    }
  }

  /deep/ .van-popup {
    background: transparent;
  }
  .popup_container {
    position: relative;
    // height: 600px;
    padding-bottom: 100px;
    box-sizing: border-box;
    .popup_wrap {
      width: 660px;
      // height: 500px;
      box-sizing: border-box;
      padding: 30px 0;
      background: #fff;
      .btn_item {
        width: 600px;
        height: 150px;
        border: 1px solid #a0a0a0;
        font-size: 30px;
        padding: 0 60px 0 68px;
        box-sizing: border-box;
        margin: 0 auto 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .icon-youjiantou {
          font-size: 30px;
          color: #515151;
        }
      }
      .textarea_box {
        border-radius: 0;
        margin-bottom: 40px;
        padding: 15px 20px;
        box-sizing: border-box;
        /deep/ .van-cell {
          padding: 0;
          width: 100%;
          height: 100%;
        }
        /deep/ .van-field__body {
          height: 100%;
        }
        /deep/ .van-field__control {
          height: 100%;
        }
      }
      .custom_btn {
        background: #373737;
        position: relative;
        .icon-yuyinjiantou {
          position: absolute;
          transform: rotate(-90deg);
          right: 20px;
        }
      }
    }
    .close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      .iconfont {
        font-size: 50px;
        color: #fff;
      }
    }
  }
}
</style>